// extracted by mini-css-extract-plugin
export default {"section":"Qy-z","sectionTitle":"Ry-z","fieldWrapper":"Sy-z","formField":"Ty-z","disabled":"Uy-z","formLabel":"Vy-z"};